import { debounce as _debounce } from 'lodash';

import stores from 'bootstrap/store';
import { prescriptionFillsManualEntryRouteStore } from '../domain/store';

const listPhysiciansAutocomplete = async (field) => {
  const suggestionsKey = `suggestions.physician.${field}`;

  prescriptionFillsManualEntryRouteStore.setValue(suggestionsKey, []);

  const currentValue = prescriptionFillsManualEntryRouteStore.physician[field];
  const response = await stores.global.physicians.listForPharmacist({
    query: {
      filter: {
        [field]: currentValue,
      },
    },
  });

  prescriptionFillsManualEntryRouteStore.setValue(suggestionsKey, response.data || []);
};

export default _debounce(listPhysiciansAutocomplete, 300);
